/*
 * @Date: 2022-06-22 18:26:54
 * @LastEditTime: 2022-09-28 14:30:59
 * @FilePath: /activity_cfhd_gmi1661411302714/index.ts
 * @Description:
 */

import { isPage } from './diyWork/config'
import { initPage } from './diyWork/init'
import LoginService from './AmsAndMilo/loginService'
import * as milo from '@tencent/milo-web'

if (isPage == 'nq') {
  window.alert = milo.miloAlert
}
console.log(milo)
LoginService(isPage)
  .checkAndLogin()
  .then((check) => {
    // 加入登录后的回调函数
    initPage() 
    console.log(check)     
  })         